import styled from "styled-components";


const PageLoader = styled.div`
  display: flex;
  flex-direction: column; 
  padding-top: 10%;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color:black;
  margin: -10px;
  

  @media only screen and (max-width: 500px){    
    padding-top: 40%;
  }
`;

const Preloader = styled.video`
    width: auto;   
    max-width: 400px;
    
`;



export default function LoadingScreen({ didVideoPlay, setDidVideoPlay }: any) {
    return (
        <PageLoader>
            <Preloader
                autoPlay
                muted
                controls={false}
                playsInline
                src="assets/preloader.mp4"
                className="vidloader"
                style={{ aspectRatio: "1" }}
                onEnded={() => setDidVideoPlay(true)}
            />            
        </PageLoader>
    );
}

